import React from 'react';
import ParticipateSection from './ParticipateSection';

const Mahotsavam = () => {
  return (
    <section id="mahotsavam" className="section bg-gradient-to-b from-purple-50 to-pink-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-saffron mb-4">
            Mahotsavam
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            The Grand Annual Festival of Sree Krishnaswamy Temple
          </p>
          <div className="decorative-border"></div>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Main Mahotsavam Content */}
          <div className="card-temple mb-12">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-saffron mb-6">
                  The Annual Mahotsavam
                </h3>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  The grand eight-day annual <em>Mahotsavam</em> is celebrated in the month of <strong>Phalguna</strong> 
                  (February-March), commencing on the day of the <strong>Karthika</strong> star and culminating 
                  on the day of the <strong>Makam</strong> star with the sacred <em>Aaratu</em> ceremony.
                </p>
                
                <p className="text-gray-700 leading-relaxed">
                  This vibrant festival was first started in <strong>1064 ME</strong> by <strong>Sri Janardhana Bhat</strong>, 
                  who served as the temple&apos;s guardian. The procession deity (Utsava Vigraham) was consecrated on Makam Star in the Phalguna month in 1064 ME. The Patakolsava was celebrated on the same day. This continues as Mahotsavam every year and devotees visit the temple from far and wide.
                </p>
              </div>
              
              <div className="text-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/3pq9v0gy_DocScanner%20Mar%2015%2C%202026%2011-45%20AM-1%282040519574048922%29.jpg"
                  alt="Sahasra Dhaara ceremony during Mahotsavam"
                  className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
                />
                <p className="text-sm text-gray-600 mt-2">Sahasra Dhaara</p>
              </div>
              
              <div className="text-center mt-8">
                <img
                  src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/6gwni0f8_44466778899.png"
                  alt="Temple ceremony"
                  className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
                />
                <p className="text-sm text-gray-600 mt-2">Rajata (Silver) Garuda Vaahana Pooja on Aarattu Day</p>
              </div>
              
              <div className="text-center mt-8">
                <img
                  src="https://customer-assets.emergentagent.com/job_krishna-temple-1/artifacts/iv7781y1_Avabhruta%20Snanam_20251006_122600_0000.png"
                  alt="Avabhruta Snanam ceremony during Mahotsavam"
                  className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
                />
              </div>
              
              <div className="text-center mt-8">
                <img
                  src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/7ybg85ig_DocScanner%20Mar%2015%2C%202026%2011-45%20AM-1%282040515886472118%29.jpg"
                  alt="Avabhruta Snanam ritual"
                  className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
                />
              </div>
              
              <div className="text-center mt-8">
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/y9fs8vmi_Prasadam%20of%20Samaaradhana_20260824_131432_0000.png"
                  alt="Samaaradhana Prasadam"
                  className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
                />
                <p className="text-sm text-gray-600 mt-2">Samaaradhana Prasadam</p>
              </div>
            </div>
          </div>

          <ParticipateSection />
        </div>
      </div>
    </section>
  );
};

export default Mahotsavam;